var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSubscriptionAlert
        ? _c(
            "el-alert",
            {
              staticClass: "subscription-alert",
              attrs: {
                title: _vm.subscriptionAlertTitle,
                type: _vm.subscriptionAlertType,
                "show-icon": "",
                closable: true
              },
              on: { close: _vm.handleSubscriptionAlertClose }
            },
            [
              _c("div", { staticClass: "alert-content" }, [
                _c("p", [_vm._v(_vm._s(_vm.subscriptionAlertMessage))]),
                _vm._v(" "),
                _c("div", { staticClass: "alert-actions" }, [
                  _c("span", { staticClass: "contact-us font400" }, [
                    _vm._v("Need assistance? Contact us at "),
                    _c(
                      "a",
                      {
                        staticClass: "contact-us-email font400",
                        attrs: {
                          target: "_blank",
                          href: "mailto:" + _vm.contactEmail
                        }
                      },
                      [_vm._v(_vm._s(_vm.contactEmail))]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2484f0d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2484f0d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uConnect/alert/uconnectActivationAlert.vue
// module id = null
// module chunks = 